import { defineStore } from 'pinia'
import api from '@/axios/api'

import { AxiosErrorHandler } from '@models/classes/axiosErrorHadler'
import { LanguageEnum } from '@models/entities/languages'
import {
  LocalizationRequestPendingEnum,
  type LocalizationRequestPendingsType
} from '@models/requests/pendings'

import { CsvToArray } from '@scripts/modules/parseCsv'

export const localizationStore = defineStore('localizationStore', {
  state: () => ({
    isReceivedDefaultLanguageTranslations: (import.meta.env.MODE ==='development') as boolean,
    translations: {} as Record<LanguageEnum, Record<string, string>>,
    requestPendings: {
      [LocalizationRequestPendingEnum.getDefaultLanguageTranslationsPending]: false
    } as LocalizationRequestPendingsType
  }),
  getters: {
    getTranslatedLanguages(): LanguageEnum[] {
      return Object.keys(this.translations) as LanguageEnum[]
    }
  },
  actions: {
    setTranslations(translations: Record<LanguageEnum, Record<string, string>>) {
      this.translations = translations
    },
    setLanguageTranslations(csvData: string) {
      const csvArray = CsvToArray(csvData)
      const languageKey = csvArray.shift()![0] as LanguageEnum

      const languageTranslations = csvArray.reduce((acc, cur) => {
        acc[cur[0]] = cur[1]
        return acc
      }, {} as Record<string, string>)

      this.setTranslations({
        ...this.translations,
        [languageKey]: languageTranslations
      })
    },
    setRequestPending(requestPending: LocalizationRequestPendingEnum, status: boolean = true) {
      this.requestPendings[requestPending] = status
    },
    async getDefaultLanguageTranslations(url: string) {
      await api.get(url)
        .then(response => {
          this.setLanguageTranslations(response.data)
          this.isReceivedDefaultLanguageTranslations = true
        })
        .catch(error => {
          new AxiosErrorHandler(error)

          if (import.meta.env.MODE !== 'development' && !this.requestPendings[LocalizationRequestPendingEnum.getDefaultLanguageTranslationsPending]) {
            this.setRequestPending(LocalizationRequestPendingEnum.getDefaultLanguageTranslationsPending)

            setTimeout(() => {
              this.setRequestPending(LocalizationRequestPendingEnum.getDefaultLanguageTranslationsPending, false)

              this.getDefaultLanguageTranslations(url)
            }, 5000)
          }
        })
    },
    getAvailableLanguagesTranslations(url: string) {
      api.get(url)
        .then(response => {
          this.setLanguageTranslations(response.data)
        })
        .catch(error => {
          new AxiosErrorHandler(error)
        })
    }
  }
})
